import firebase from 'firebase/compat/app';

/**
 * Dev-only notification kill switch.
 *
 * Returns true only when BOTH:
 *  - the app is running the Vite `development` build, AND
 *  - `config/notificationSettings.captureDevNotifications === true`.
 *
 * When true, notification hooks skip all real delivery (in-app + email) and
 * instead log a summary to the console — so a developer working against the
 * live Firestore data doesn't spam the real team.
 *
 * Prod builds short-circuit before any Firestore read (`MODE !== 'development'`),
 * so this is free outside of local development.
 */
export default async function isCapturingDevNotifications(db: firebase.firestore.Firestore): Promise<boolean> {
  if (import.meta.env.MODE !== 'development') return false;
  try {
    const snap = await db.collection('config').doc('notificationSettings').get();
    return snap.data()?.captureDevNotifications === true;
  } catch (error) {
    console.error('isCapturingDevNotifications: failed to read config/notificationSettings', error);
    return false;
  }
}
